module.exports = __webpack_public_path__ + "img/spring_trip-20160416-17.86665352.jpg";